import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './auth';
import { notificationsService } from '../services/notificationsService';
import { database } from '../firebase/config';

const NotificationsContext = createContext({});

export function NotificationsProvider({ children }) {
  const { user, loading } = useAuth();
  const [notificacoes, setNotificacoes] = useState([]);
  const [novasNotificacoes, setNovasNotificacoes] = useState(0);

  useEffect(() => {

    // Aguardar até o carregamento terminar
    if (loading) {
      return;
    }

    // Verificar se o usuário está autenticado
    if (!user || !user.id) {
      setNotificacoes([]);
      setNovasNotificacoes(0);
      return;
    }

    // Verificar se o Firebase Database está configurado
    if (!database) {
      return;
    }

    const unsubscribe = notificationsService.escutarNotificacoes(user.id, (novasNotificacoesList) => {
      
      if (!Array.isArray(novasNotificacoesList)) return;
      
      // Atualizar lista de notificações
      setNotificacoes(novasNotificacoesList);
      setNovasNotificacoes(novasNotificacoesList.length);
      
      // Log para debug - sem disparo de notificação do navegador
      if (novasNotificacoesList.length > 0) {
        console.log('NotificationsContext: Recebidas', novasNotificacoesList.length, 'notificações');
      }
    });

    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, [user, loading]);

  const marcarComoLida = async (notificacaoId) => {
    if (!user?.id || !notificacaoId) return;
    
    try {
      await notificationsService.marcarComoLida(user.id, notificacaoId);
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error);
    }
  };

  return (
    <NotificationsContext.Provider value={{
      notificacoes,
      novasNotificacoes,
      marcarComoLida
    }}>
      {children}
    </NotificationsContext.Provider>
  );
}

export function useNotifications() {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotifications deve ser usado dentro de um NotificationsProvider');
  }
  return context;
}
